import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { AtividadeEvents } from '../models/atividade-events';
import { AtividadeEventsService } from './atividade-events.service';
import { AtividadeService } from '../atividade.service';


@Component({
    selector: 'mf-atividade-events',
    templateUrl: './atividade-events.component.html',
    styleUrls: ['atividade-events.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        TableModule
    ]
})
export class AtividadeEventsComponent implements OnInit {
  atividadeEvents: AtividadeEvents[] = [];
  @Input() idAtividade: number = 0;
  loading: boolean = false;
  @Output() loadLista = new EventEmitter<AtividadeEvents[]>();

  constructor(
    private atividadeEventsService: AtividadeEventsService,
    private atividadeService: AtividadeService
  ) {}

  ngOnInit(): void {
    this.getAtividadeEventos();

    this.atividadeService.atividadeEvents.subscribe(
      () => {
        this.getAtividadeEventos();
      },
      (err) => {}
    );
  }

  getAtividadeEventos() {
    this.loading = true;
    this.atividadeEventsService.getAtividadeEventos(this.idAtividade).subscribe((data) => {
      this.atividadeEvents = data;
      this.loadLista.emit(this.atividadeEvents);
      this.loading = false;
    });
  }
}
